import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../data/store'
import { getNetworkResponseError, isStatusOK } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { apiConfig } from './config'
import { sendEventApi } from './sendEvent'
// import { sendEventApi } from './sendEvent'

const responseParser = (data: any) => {
  console.log(data, 'datacheckformresponseparser::')
  if (isStatusOK(data) && data?.data?.sessionToken) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data || data)
  }
}
const getUniqueDeviceSessionRequest = (agentUserId, channelId, hash, agentID, timeStamp) => {
  console.log(hash, timeStamp, agentID, 'checkrequestmapper::')
  return {
    // data: {
    deviceId: `${hash}`,
    agentUserId: `${agentID}|WEB`,
    deviceTimestamp: timeStamp,
    deviceInfo: JSON.stringify(RootStore.agent.deviceInfo),
    latitude: RootStore.agent.deviceInfo?.latitude,
    longitude: RootStore.agent.deviceInfo?.longitude,
    channelId,
    sessionId: null,
    // }
  }
}
export const sendUniqueDeviceSession = (
  tokens: any,
  agentUserLoginId: string,
  hash?: string,
  agentID?: string,
  timeStamp?: number,
) => {
  const config = apiConfig(tokens)
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers.userIDToken = RootStore?.bcAppInfo?.userIdentifier
  console.log(RootStore.agent.deviceInfo?.latitude, 'checklatvalue::')
  console.log(RootStore.agent.deviceInfo?.longitude, 'checklongvalue::')
  const request: Request<{}> = {
    apiPath: `${APIEndPoints.getUniqueDeviceSession}`,
    method: 'POST',
    config: config,
    cache: false,
    body: getUniqueDeviceSessionRequest(agentUserLoginId, tokens?.CHANNEL_ID, hash, agentID, timeStamp),
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      console.log('HTAG DATA getAgentUserInformation', data)
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      return responseParser(err)
    })
}
